export class Page {
   pageSize: number = 10;
   totalElements: number = 1993;
   totalPages: number = 399;
   pageNumber: number = 0;
   pageSizes = [5, 10, 25, 50, 100];
}
